import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslate } from "react-polyglot";
import { Box, Typography, Popover, makeStyles } from "@material-ui/core";
import { processHintPopups } from "../Utils/misc.js";

// в news не срабатывает. Возможно не обновляется отображение после изменения.  Нужно дорабатывать.

const useStyles = makeStyles(() => ({
  popover: {
    pointerEvents: "none",
  },
}));

/**
 * @param {String} text
 * @param {Object} className
 * @param {Object} rest
 * @return {React.ReactNode}
 */
const TextWithHTML = ({ text, className, ...rest }) => {
  const t = useTranslate();
  const classes = useStyles();
  const [parseText, setParseText] = useState(null);
  const [hintLink, setHintLink] = useState(null);
  const [popoverContent, setPopoverContent] = useState(null);
  const [availablePopoverContent, setAvailablePopoverContent] = useState(/** @type Object.<string, string> */ null);

  // вся необходимая обработка текста (замена ссылок, bbcod-а, тройного слэша (///), санитаризация)
  useEffect(() => {
    if (text) {
      const preparsed = text.replaceUrlsOutsideTags().processSpoilers();
      const { html, hintsContent } = processHintPopups(preparsed);
      setAvailablePopoverContent(hintsContent);
      setParseText(html.sanitizedData());
    }
  }, [text]);

  // После монтирования компонентов находим в обработанном тексте с помощью querySelector и querySelectorAll элементы,
  // которыми заменили bbcod "[spoiler]" и "///", добавляем для них обработчик кликов.
  // Делаем в отдельном  useEffect, так как в первом еще не смонтировались компоненты и querySelector querySelectorAll ничего не находят.
  useEffect(() => {
    if (parseText) {
      const spoilerLinks = document.querySelectorAll(".spoiler");
      const slashLink = document.querySelector(".slash");
      if (slashLink) {
        const id = slashLink.id;
        const afterSlash = document.getElementById(`div-${id}`);
        slashLink.textContent = t("showMore");
        if (afterSlash) {
          slashLink.onclick = () => {
            afterSlash.style.display = afterSlash.style.display === "none" ? "block" : "none";
            slashLink.textContent = afterSlash.style.display === "none" ? t("showMore") : t("hide");
          };
        }
      }
      if (spoilerLinks.length > 0) {
        spoilerLinks.forEach((element) => {
          const id = element.id;
          const spoiler = document.getElementById(`div-${id}`);
          const arrow = document.getElementById(`spoilerArrow${id}`);
          arrow.style =
            "display: inline-block; font-size: 1.5em; font-weight: bold; margin-right: 8px; transform: translateY(3px); transform-origin: 45% 55%;";
          element.onclick = () => {
            spoiler.style.display = spoiler.style.display === "none" ? "block" : "none";
            arrow.style.transform =
              spoiler.style.display === "none" ? "translateY(3px)" : "rotate(90deg) translateX(2px)";
          };
        });
      }
    }
  }, [parseText]);

  // Навешивание обработчиков кликов на хинты, если они есть.
  useEffect(() => {
    const hintLinks = document.querySelectorAll("[id^=popupLink]");
    hintLinks.forEach((element) => {
      const linkId = element.id.replace("popupLink", "");
      element.addEventListener("click", () => {
        setPopoverContent(availablePopoverContent[linkId].sanitizedData());
        setHintLink(element);
      });
      element.addEventListener("mouseleave", () => setHintLink(null));
    });
  }, [parseText, availablePopoverContent]);

  // для поповера
  const open = Boolean(hintLink);

  /** */
  const closePopover = () => {
    setHintLink(null);
  };

  return (
    <>
      {text && (
        <Typography className={className} {...rest}>
          <span dangerouslySetInnerHTML={parseText} />
        </Typography>
      )}
      <Popover
        className={classes.popover}
        open={open}
        anchorEl={hintLink}
        onClose={closePopover}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box padding="5px 10px" maxWidth="800px" dangerouslySetInnerHTML={popoverContent} />
      </Popover>
    </>
  );
};

TextWithHTML.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default TextWithHTML;
